import { observer } from 'mobx-react';
import { Toggle } from 'office-ui-fabric-react/lib/components/Toggle';
import store from 'owa-mail-store/lib/store/Store';
import { lazyClientOptOut } from 'owa-mail-triage-action';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
var styles = require('./MailCommandingBar.scss');
export function renderOptOut(item) {
    var label = getUserConfiguration().SessionSettings.WebSessionType === 1 /* ExoConsumer */
        ? strings.optOutToggleLabel
        : strings.optOutEnterpriseToggleLabel;
    var OptOutComponent = observer(function () { return (React.createElement("div", { onClick: onOptOutToggle, className: styles.toggleWrapper },
        React.createElement(Toggle, { className: styles.optOutToggle, checked: store.clientOptedIn, onText: label, offText: label, offAriaLabel: label, onAriaLabel: label, onClick: onOptOutToggle }))); });
    return React.createElement(OptOutComponent, null);
}
export function onOptOutToggle(event) {
    event.stopPropagation();
    event.preventDefault();
    lazyClientOptOut.importAndExecute();
}
//# sourceMappingURL=ClientOptOutItem.js.map